import component from './selectTreeMixedSegments.vue'

export default component
